import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
  CircularProgress
} from '@mui/material';
import { HighlightOff as CancelIcon } from '@mui/icons-material';
import { useThemeSettings } from '../../../../contexts/ThemeContext';

/**
 * Dialog for cancelling an intervention
 */
const CancelInterventionDialog = ({
  open,
  onClose,
  onSubmit,
  cancelling = false
}) => {
  const { t } = useThemeSettings();

  // Form state
  const [reason, setReason] = useState('');

  // Reset form when dialog opens
  useEffect(() => {
    if (open) {
      setReason('');
    }
  }, [open]);

  const handleSubmit = () => {
    onSubmit(reason.trim());
  };

  const handleClose = () => {
    if (!cancelling) {
      setReason('');
      onClose();
    }
  };

  const isReasonValid = reason && reason.trim() !== '';

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        {t ? t("Tickets.cancel_intervention") : "Cancel Intervention"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          {t ? t("Tickets.cancel_confirmation") : "Are you sure you want to cancel this intervention? Calendar items will be removed and all followers will be notified."}
        </DialogContentText>

        <TextField
          label={t ? t("Tickets.cancellation_reason") : "Cancellation Reason"}
          multiline
          rows={4}
          fullWidth
          required
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder={t ? t("Tickets.cancellation_reason_placeholder") : "Please provide a reason for cancelling the intervention (required)..."}
          helperText={t ? t("Tickets.cancellation_reason_note") : "This reason will be included in the notification email"}
          error={!isReasonValid && reason !== ''}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={cancelling}>
          {t ? t("Tickets.go_back") : "Go Back"}
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="error"
          disabled={cancelling || !isReasonValid}
          startIcon={cancelling ? <CircularProgress size={20} /> : <CancelIcon />}
        >
          {cancelling
            ? (t ? t("Tickets.cancelling") : "Cancelling...")
            : (t ? t("Tickets.cancel_intervention") : "Cancel Intervention")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CancelInterventionDialog;
